import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import _ from 'lodash';
import { ModalContext } from 'App';
import PinInput from 'modules/common/components/PinInput';
import CountdownComponent from 'modules/common/components/CountdownComponent';
import Modal from 'modules/common/components/Modal';
import * as actions from '../action';
import * as c from '../constant';

function EmailSetupModal({ sendEmail, history,
  isLoading,
  resending,
  profileInfo,
  validateEmail,
  getProfile
}) {

  const setModal = useContext(ModalContext);

  const [showOTP, setShowOTP] = useState(false);
  const [rand, setRand] = useState(_.random(1, 1000));

  const [formData, setFormData] = useState({
    email: _.get(profileInfo, 'attributes.email')
  });

  const commonValidation = {
    email: 'required',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.onSetObjectRules(commonValidation)
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnchangePin = secret => {
    setFormData({
      ...formData,
      secret
    });
  };

  const secretEmail = val => {
    return [...val].map((item, i) => (i > 1 && i < 9 ? "*" : item));
  };

  const handleNext = () => {
    const args = {
      email: formData.email,
    };
    sendEmail(args, () => {
      setShowOTP(true);
    });
  };

  const handleOTP = (e) => {
    e.preventDefault();

    validateEmail(formData, () => {
      setModal({ isOpen: false });
      getProfile();
      history.push('/profile');
    });
  };

  const handleResendOtp = e => {
    e.preventDefault();
    const args = {
      email: formData.email,
    };
    sendEmail(args, () => {
      setRand(_.random(1, 1000));
      setShowOTP(true);
    });
  };

  return (
    <Modal.Body>
      <div className="mfa-modal">
        <>
          {!showOTP && (
            <>
              <div className="mfa-modal">
                <div className='cms-text-primary cms-outline-primary'>
                  To continue setting up Email Authentication for your account, please confirm your email address below:
                </div>
                <div className="form-group mt-2">
                  <label className="form-label pb-1">
                    Email Address {validateForm.renderMessage('email')}
                  </label>
                  <input
                    type="email"
                    placeholder="Email Address"
                    onChange={handleOnChange}
                    name="email"
                    value={_.get(formData, 'email') || ''}
                    id="loginUsername"
                    disabled
                    className="form-control form-control-lg"
                    style={{ border: '1px solid #D3D3D3', borderRadius: '8px' }} // smart-city
                  />
                </div>
              </div>
              <hr className='below-hr' />
              <div className="mfa-modal">
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    onClick={handleNext}
                    disabled={formData.email === ''}
                    className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
                  >
                    <span className="font-weight-bold">
                      Continue
                    </span>
                  </button>
                </div>
              </div>
            </>
          )}
          {showOTP && (
            <form className="mfa-modal" onSubmit={handleOTP}>
              <div className="form-header p-3">
                <span
                  className="text-color text-center"
                >
                  We sent your One Time Password (OTP) to{" "}
                </span>
                <span className="email-text">
                  {_.get(formData, "email")
                    ? secretEmail(
                      _.get(formData, "email")
                    ) : secretEmail(_.get(formData, 'email'))}
                </span>
              </div>
              <div className="col-12">
                <PinInput onChange={handleOnchangePin} />
              </div>
              <div className="col-12 mt-2 text-center">
                <CountdownComponent key={`countdown-${rand}`} />
              </div>
              <div className="d-flex flex-column flex-md-row flex-lg-row flex-xl-row text-center">
                <div className="col-12 col-md-6">
                  <button
                    onClick={handleResendOtp}
                    type="submit"
                    className="btn btn-primary mt-4 btn-block cms-bg-color-primary"
                  >
                    {resending && <i className="fa fa-spin fa-spinner" />}{" "}
                    <span className='mr-2 label-small'>Resend OTP</span>
                  </button>
                </div>
                <div className="col-12 col-md-6">
                  <button
                    type="submit"
                    className="btn btn-primary mt-4 btn-block cms-bg-color-primary"
                    disabled={isLoading || _.isEmpty(formData.secret)}
                  >
                    {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
                    Submit
                  </button>
                </div>
              </div>
            </form>
          )}
        </>
      </div>
    </Modal.Body>
  );
}

EmailSetupModal.propTypes = {
  profileInfo: PropTypes.instanceOf(Object).isRequired,
  sendEmail: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  validateEmail: PropTypes.instanceOf(Function).isRequired,
  getProfile: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.VALIDATE_EMAIL) > -1,
  resending: _.get(api, "loading", []).indexOf(c.SEND_EMAIL) > -1,
});


const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(EmailSetupModal);